<template>
  <div
    v-touch="{
      left: () => swipe('Left'),
      right: () => swipe('Right'),
      up: () => swipe('Up'),
      down: () => swipe('Down'),
    }"
  >
    <v-alert outlined color="black">
      <div class="text-h6 text-center">TERMS AND CONDITIONS</div>
      <div>
        <ul>
          <li>
            Your personal information is widely used on the TATNAYWON PROPERTY
            website. The personal information collected on this website will be
            used to support the services provided by external organizations.
          </li>
          <br />

          <li>
            The TATNAYWON PROPERTY website can be used for your data to be
            marketing and service to get more customers.
          </li>
          <br />

          <li>
            The TATNAYWON PROPERTY website allows you to change your information
            at any time.
          </li>
          <br />

          <li>
            Our website targets to make your real estate ads attractive and easy
            to sell and buy.
          </li>
          <br />

          <li>
            If your data deal with ads is widely used, we will serve you
            promotional offers via email or phone call .
          </li>
          <br />

          <li>
            If you believe that breach and agreements of TATNAYWON PROPERTY and
            your website infringes on the property or rights of other customers
            ,The Tat nay won property website uses your personal information and
            then this will be done in accordance with the law.
          </li>
          <br />

          <li>
            If you terminate registration on the TATNAYWON PROPERTY, we' ll
            permanently delete your information.
          </li>
          <br />

          <li>
            You can access to use and free to share any post on the TATNAYWON
            PROPERTY website.
          </li>
          <br />

          <li>
            For those who have created REGISTER on our website, the information
            not related to business ads will not be allowed to upload.
          </li>
          <br />

          <li>
            All users in accordance with the terms and conditions can free to
            share their data on the TATNAYWON PROPERTY Website.
          </li>
          <br />

          <li>
            Only after agreeing to receive emails from the TATNAYWON PROPERTY
            website, as it agrees to accept links with external organizations
            and sending emails, for those who do not agree with it ,some of the
            rules do not apply to emails sent from the TATNAYWON PROPERTY
            website.
          </li>
          <br />

          <li>
            The security arrangements of the TATNAYWON PROPERTY website will
            guarante to be protected from illegally entry, and stealing your
            information Or from change .
          </li>
        </ul>
      </div>
    </v-alert>
  </div>
</template>

<script>
export default {
  name: "Terms",

  methods: {
    swipe(direction) {
      this.swipeDirection = direction;
      if (direction) {
        if (direction === "Right") {
          this.$router.go(-1);
        }
      }
    },
  },
};
</script>
